import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { submitContact } from "@/lib/api";

const EMPTY = { name: "", email: "", phone: "", message: "" };

export default function ContactForm() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitContact(form);
      toast.success("Message received. We will get back to you shortly.");
      setForm(EMPTY);
    } catch {
      toast.error("Something went wrong. Please try again or email hello@talentifyhs.com.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="contact-form" onSubmit={onSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <input data-testid="contact-name-input" required value={form.name} onChange={set("name")} placeholder="Name *" className="input-dark" aria-label="Name" />
        <input data-testid="contact-email-input" required type="email" value={form.email} onChange={set("email")} placeholder="Email *" className="input-dark" aria-label="Email" />
      </div>
      <input data-testid="contact-phone-input" type="tel" value={form.phone} onChange={set("phone")} placeholder="Phone" className="input-dark" aria-label="Phone" />
      <textarea data-testid="contact-message-input" required value={form.message} onChange={set("message")} placeholder="How can we help? *" rows={5} className="input-dark resize-none" aria-label="Message" />
      <button
        data-testid="contact-form-submit-button"
        type="submit"
        disabled={loading}
        className="group inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-3.5 text-sm font-semibold text-white shadow-[0_8px_30px_rgba(37,99,235,0.35)] transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:bg-blue-500 disabled:opacity-60"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />}
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>
  );
}
